import { GetInstructionModel } from './../../models/get-instruction.model';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { LocalStorageKeys } from '../../models/local-storage-keys.model';
import { DashboardService } from '../../services/dashboard.service';
import { LocalCacheService } from '../../services/local-cache.service';
import {
  GetBuildingsPerManagement,
  GetBuildingsPerMunicipality,
  GetBuildingsPerPeriod,
  GetDashboard,
  GetUserInstruction,
} from '../action/dashboard.action';
import { BuildingsPerManagementModel } from './../../models/building-per-management.model';
import { BuildingsPerMunicipalityModel } from './../../models/buildings-per-municipality.model';
import { BuildingsPerPeriodModel } from './../../models/buildings-per-period.model';
import { DashboardModel } from './../../models/dashboard.model';
import { LocalCacheModel } from './../../models/local-cache.model';

export interface DashboardStateModel {
  statistics?: DashboardModel;
  buildingsPerPeriod: BuildingsPerPeriodModel[];
  buildingsPerMunicipality: BuildingsPerMunicipalityModel[];
  buildingsPerManagement: BuildingsPerManagementModel[];
  userInstructionContent: GetInstructionModel;
}

@State<DashboardStateModel>({
  name: 'dashboardstate',
  defaults: {
    buildingsPerPeriod: [],
    buildingsPerMunicipality: [],
    buildingsPerManagement: [],
    userInstructionContent: undefined,
  },
})
@Injectable()
export class DashboardState {
  constructor(
    private dashboardService: DashboardService,
    private localCacheService: LocalCacheService
  ) {}

  @Selector()
  static buildingsPerManagement(ctx: DashboardStateModel) {
    return ctx.buildingsPerManagement;
  }

  @Selector()
  static buildingsPerMunicipality(ctx: DashboardStateModel) {
    return ctx.buildingsPerMunicipality;
  }

  @Selector()
  static buildingsPerPeriod(ctx: DashboardStateModel) {
    return ctx.buildingsPerPeriod;
  }

  @Selector()
  static statistics(ctx: DashboardStateModel) {
    return ctx.statistics;
  }

  @Selector()
  static userInstructionContent(ctx: DashboardStateModel) {
    return ctx.userInstructionContent;
  }

  @Action(GetDashboard)
  async getDashboard(
    ctx: StateContext<DashboardStateModel>,
    action: GetDashboard
  ) {
    let data: DashboardModel;
    data = await this.dashboardService.getStatistics(action.language).toPromise();

    if (data) {
      ctx.patchState({
        statistics: data,
      });
    }
  }

  @Action(GetBuildingsPerPeriod)
  async getBuildingsPerPeriod(
    ctx: StateContext<DashboardStateModel>,
    action: GetBuildingsPerPeriod
  ) {
    const data = await this.dashboardService
      .getBuildingsPerPeriod()
      .toPromise();

    if (data) {
      ctx.patchState({
        buildingsPerPeriod: data,
      });
    }
  }

  @Action(GetBuildingsPerMunicipality)
  async getBuildingsPerMunicipality(
    ctx: StateContext<DashboardStateModel>,
    action: GetBuildingsPerMunicipality
  ) {
    const data = await this.dashboardService
      .getBuildingsPerMunicipality()
      .toPromise();

    if (data) {
      ctx.patchState({
        buildingsPerMunicipality: data,
      });
    }
  }

  @Action(GetBuildingsPerManagement)
  async getBuildingsPerManagement(
    ctx: StateContext<DashboardStateModel>,
    action: GetBuildingsPerManagement
  ) {
    const data = await this.dashboardService
      .getBuildingsPerManagement()
      .toPromise();

    if (data) {
      ctx.patchState({
        buildingsPerManagement: data,
      });
    }
  }

  @Action(GetUserInstruction)
  async getUserInstruction(
    ctx: StateContext<DashboardStateModel>,
    action: GetUserInstruction
  ) {
    const data = await this.dashboardService
      .getUserInstruction(action.language)
      .toPromise();

    if (data) {
      ctx.patchState({
        userInstructionContent: data,
      });
    }
  }
}
